import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class FacilityCredentialService extends BaseService {
  search = (data) => this.axios.post(API_ENDPOINTS.FACILITY_CREDENTIAL_SEARCH, data);

  getDetail = ({ facilityCredentialId }) =>
    this.axios.get(
      API_ENDPOINTS.FACILITY_CREDENTIAL_DETAIL.replace(
        "{facilityCredentialId}",
        facilityCredentialId
      )
    );

  create = (data) => this.axios.post(API_ENDPOINTS.FACILITY_CREDENTIAL_CREATE, data);

  update = (data) =>
    this.axios.put(
      API_ENDPOINTS.FACILITY_CREDENTIAL_UPDATE.replace(
        "{facilityCredentialId}",
        data.facilityCredentialId
      ),
      data
    );

  delete = ({ facilityCredentialId }) =>
    this.axios.delete(
      API_ENDPOINTS.FACILITY_CREDENTIAL_DELETE.replace(
        "{facilityCredentialId}",
        facilityCredentialId
      )
    );

  updateExpiredDate = ({ facilityCredentialId, otaId, ...data }) =>
    this.axios.put(
      API_ENDPOINTS.FACILITY_CREDENTIAL_RENEW_PROFILE_OTA.replace(
        "{facilityCredentialId}",
        facilityCredentialId
      ).replace("{otaId}", otaId),
      { ...data, otaId }
    );

  getMergedStoreOtas = (storeIds) =>
    this.axios.post(API_ENDPOINTS.FACILITY_CREDENTIAL_MERGED_STORE_OTAS, storeIds);

  getLinkedStores = (storeIds) =>
    this.axios.post(API_ENDPOINTS.FACILITY_CREDENTIAL_LINKED_STORES, storeIds);

  getForCrawlSelect = () =>
    this.axios.post(API_ENDPOINTS.FACILITY_CREDENTIAL_FOR_CRAWL_SELECT, {});
}
